import React from 'react';
import { Link } from 'react-router-dom';
import { useSeo } from '../seo/useSeo';
import SEO_PAGES from '../seo/pages.json';

const About = () => {
  useSeo({ ...SEO_PAGES['/about'], canonicalPath: '/about' });

  return (
    <div className="about-page">
      <header className="about-page-header">
        <p className="offering-feature-eyebrow">Disco Duck Events</p>
        <h1>Our Story</h1>
        <p className="about-page-intro">
          A Kansas City family business built around capturing the moments people actually want to remember.
        </p>
      </header>

      <section className="about-page-story">
        <div className="about-page-photo">
          <img
            src="/our_story_photo.jpg"
            alt="Sydney and Aidan with their daughter"
            loading="lazy"
            decoding="async"
          />
        </div>

        <div className="about-page-text">
          <div className="about-page-block">
            <h2>Family Business</h2>
            <p>
              Sydney and Aidan run Disco Duck Events with a passion for creating beautiful, memorable experiences.
              As parents with a young family, they understand the importance of capturing life&rsquo;s precious moments.
            </p>
          </div>

          <div className="about-page-block">
            <h2>International Expertise</h2>
            <p>
              Aidan brings extensive experience in event construction from high-end events internationally,
              with a focus on luxury events in London. Together, they bring world-class event experiences to
              Kansas City.
            </p>
          </div>
        </div>
      </section>

      <section className="about-page-cta">
        <h2>Let&rsquo;s make your event one to remember</h2>
        <p>Tell us what you&rsquo;re planning and we&rsquo;ll send over a personalized quote.</p>
        <Link to="/contact" className="offering-feature-btn" data-track="about">
          Check Availability <span aria-hidden="true">&rarr;</span>
        </Link>
      </section>
    </div>
  );
};

export default About;
